export default "__VITE_ASSET__02796e63__"